import {Component, OnInit} from '@angular/core';
import {NgClass} from "@angular/common";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {SessionStorageService} from "../../core/services/session-storage.service";
import {InstitutesService} from "../../api/services/institutes.service";
import {Router} from "@angular/router";
import {DocumentItem} from "../../api/models/pending-document.model";
import {AdmissionsService} from "../../api/services/admissions.service";
import {storageKey} from "../../api/enum/storage.constants";
import {BaseService} from "../../api/services/base.service";
import {HttpEvent, HttpEventType} from "@angular/common/http";
import {ApiResponse} from "../../api/api-response.model";
import {HumanizeConstantPipe} from "../../shared/pipes/humanizeConstant.pipe";

@Component({
    selector: 'app-upload-document',
    imports: [
        ReactiveFormsModule,
        NgClass,
        HumanizeConstantPipe
    ],
    templateUrl: './upload-document.component.html',
    styleUrl: './upload-document.component.scss'
})
export class UploadDocumentComponent implements OnInit {
    documentUploadForm: FormGroup;
    errorMessage = '';
    showError = false;

    loading = false;

    enumData: any;
    documentItems: DocumentItem[] = [];

    constructor(
        private fb: FormBuilder,
        private storage: SessionStorageService,
        private baseService: BaseService,
        private instituteService: InstitutesService,
        private admissionService: AdmissionsService,
        private router: Router
    ) {
        this.documentUploadForm = this.fb.group({});
    }

    ngOnInit(): void {
        const applicationNumber = <string>this.storage.get(storageKey.applicationNumber)

        this.admissionService.getPendingDocuments(applicationNumber).subscribe({
            next: (response) => {
                if (response?.data) {
                    this.documentItems = response.data.documents;
                }
            },
            error: (err) => {
                if (err.status !== 200) {
                    this.errorMessage = err.error?.message?.message || 'Something went wrong.';
                    this.showError = true;
                }
            }
        });
    }

    onFileSelect(event: any, doc: DocumentItem) {
        const file = event.target.files[0];
        if (!file) return;

        doc.file = file;
        doc.progress = 0;
        doc.uploadedUrl = null;

        this.baseService.upload(file).subscribe({
            next: (event: HttpEvent<any>) => {
                if (event.type === HttpEventType.UploadProgress) {
                    // Calculate percentage
                    if (event.total) {
                        doc.progress = Math.round((100 * event.loaded) / event.total);
                    }
                } else if (event.type === HttpEventType.Response) {
                    if (!event.body?.error && event.body?.data?.url) {
                        doc.progress = 100;
                        doc.uploadedUrl = event.body.data.url;
                        console.log('Upload complete:', doc.uploadedUrl);
                    } else {
                        doc.progress = -1;
                        console.log("Upload error")
                    }
                }
            },
            error: (err) => {
                doc.progress = -1; // Flag to show "Failed" in the UI
                console.error('Upload error:', err);
            }
        });
    }


    canSubmit(): boolean {
        return this.documentItems &&
            this.documentItems.length > 0 &&
            this.documentItems.every(d => d.uploadedUrl && d.uploadedUrl !== null);
    }


    onSubmit(): void {
        this.loading = true
        const applicationNumber = <string>this.storage.get(storageKey.applicationNumber)
        const payload = {
            application_number: parseInt(applicationNumber),
            uploaded_documents: this.documentItems.map(doc => ({
                id: doc.id,
                uploaded_url: doc.uploadedUrl ?? null
            }))
        };

        this.admissionService.uploadDocuments(payload).subscribe({
            next: (response: ApiResponse<any>) => {
                this.documentItems = []
                this.router.navigate(['thank-you'])
            },
            error: (error) => {
                console.error('Upload error:', error);
            }
        });
    }
}
